import React, { Suspense, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header from '../components/institutional/Header'
import Footer from '../components/institutional/Footer'
import ErrorBoundary from '../components/ErrorBoundary'
import { Loader2 } from 'lucide-react'
import { initGA4, trackPageView } from '../utils/analytics'
import { applyMetaTags, PAGE_CONFIGS, generateMetaTags } from '../utils/seo'

// Loading component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="text-center">
      <Loader2 className="w-8 h-8 animate-spin text-primary-600 mx-auto mb-4" />
      <p className="text-secondary-600">Carregando...</p>
    </div>
  </div>
)

const InstitutionalLayout = () => {
  const location = useLocation()

  // Inicializar Analytics na primeira carga
  useEffect(() => {
    initGA4()
  }, [])

  // Aplicar SEO e tracking quando a rota mudar
  useEffect(() => {
    // Determinar a página atual baseada na rota
    const pathToPageKey = {
      '/': 'home',
      '/sobre': 'about',
      '/funcionalidades': 'features',
      '/planos': 'pricing',
      '/cases': 'cases',
      '/contato': 'contact',
      '/plataforma': 'platform',
      '/como-funciona': 'workflow-demo',
      '/pequenas-empresas': 'small-business',
      '/api': 'api',
      '/rh': 'hr',
      '/icp-brasil': 'icp-brasil',
      '/advocacia': 'law',
      '/imobiliaria': 'real-estate',
      '/saude': 'healthcare',
      '/blog': 'blog',
      '/seguranca': 'security'
    }

    const currentPageKey = pathToPageKey[location.pathname]
    if (currentPageKey && PAGE_CONFIGS[currentPageKey]) {
      const pageConfig = PAGE_CONFIGS[currentPageKey]
      // Aplicar meta tags SEO
      const metaTags = generateMetaTags(pageConfig)
      applyMetaTags(metaTags)

      // Tracking de page view
      trackPageView(pageConfig.title, location.pathname)
    }
  }, [location.pathname])

  return (
    <div className="min-h-screen flex flex-col">
      <ErrorBoundary>
        <Header />

        <main className="flex-1">
          <Suspense fallback={<PageLoader />}>
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </Suspense>
        </main>

        <Footer />

        {/* WhatsApp Button flutuante - temporariamente desabilitado
        <WhatsAppButton
          phoneNumber="5511999999999"
          showOnScroll={true}
        />
        */}
      </ErrorBoundary>
    </div>
  )
}

export default InstitutionalLayout
